<script>
import 'vue3-carousel/dist/carousel.css';
import {Carousel, Slide} from 'vue3-carousel';
import {ref} from "vue";
import {useStore} from "vuex";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";
import router from "@/router";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "HomePage",
  components: {LoadingPage, BottomNavigation, Carousel, Slide},
  setup() {

    let store = useStore()
    let orders = store.state.order
    store.commit('set_categoryPage_filter' , 'delete')
    store.commit('set_categoryProducts_filter' , 'delete')
    store.commit('set_storePage_filter' , 'delete')

    if (orders.offer){
      store.commit('EmptyBasket')
      store.commit('set_offer', null)
    }

    let loading = ref(false)
    let HomePage = ref({
      best_selling: [],
      best_shops: [],
      guilds:{
        category: []
      },
      slider: []
    })
    let text_search = ref('')

    let count_orders = ref(store.state.order.products.length)

    function load_data() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'homepage', true).then((res) => {

        loading.value = false
        HomePage.value = res.data

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, load_data)
      })

    }
    load_data()

    function click_option(action , item) {

      if (action === 'slider') {
        if (item.link != null) {
          window.location.href = item.link
        }
      }

      if (action === 'cart'){
        if (count_orders.value === 0){
          Swals.Warning('سبد خرید شما خالی است!')
        }else{
          router.push({name:'CartPage'})
        }
      }

    }

    function search() {

      if (text_search.value.trim().length == 0){
        Swals.Warning('لطفا نام محصول یا برند مورد نظر خود را وارد کنید')
      }else {
      router.push({name:'SearchBy' , params:{text:text_search.value}})
      }

    }


    return {
      HomePage,
      click_option,
      text_search,
      search,
      count_orders,
      loading,
    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="p-body mt-4">

      <div class="d-flex justify-content-between mb-4">

        <div style="padding:2rem" class="bg-white px-3 rounded-3 shadow-custom w-80 position-relative">
          <img @click="search" class="position-absolute icon_search max_width" src="../assets/img/search_color.svg" alt="">

          <input v-model="text_search" @keyup.enter="search" style="top: 50%;left: 2%;transform: translate(0, -50%);" class="font-5 position-absolute text-center w-90" type="search" placeholder="به دنبال چه محصولی هستی؟">
        </div>

        <div @click="click_option('cart')" class="bg-white d-flex justify-content-center align-items-center p-3 rounded-3 position-relative shadow-custom">
          <p v-if="count_orders !== 0" style="right: -10px;bottom: -10px" class="text-white font-5 bg-green rounded-pill py-1 px-2 border-custom position-absolute">{{ count_orders }}</p>
          <img class="icon-size-4" src="../assets/img/shopping-cart.svg" alt="">
        </div>

      </div>

      <div style="height: 9.5rem" class="list_category align-items-center mb-4">

        <router-link dir="rtl" class="text-decoration-none" v-for="item in HomePage.guilds.category" :key="item.id" :to="{name:'CategoryPage' , params:{cid:item.id}}">

          <div class="div_category ml-3 d-flex flex-column justify-content-between align-items-center p-2 bg-white rounded-3 shadow-custom">
            <div class="img_category animated-background mb-2">
              <img class="img_category" :src="item.pic" alt="">
            </div>

            <div class="overflow-hidden w-100 d-flex justify-content-center">
            <p style="white-space: nowrap" class="font-5 text-center" :class="item.name.length >= 14 ? 'txtoverflow':''">{{ item.name }}</p>
            </div>
          </div>

        </router-link>

      </div>

      <div class="d-flex justify-content-between align-items-center position-relative mb-4">
        <div style="height: 5px" class="position-absolute bg-color-light w-100 center-y"></div>
        <img style="width: 3.7rem" class="font-4 p-3 bg-white rounded-3 position-relative" src="../assets/img/store_light.svg">

        <p class="font-4 p-3 bg-white rounded-3 w-50 text-center position-relative">برترین فروشندگان</p>
        <router-link :to="{name:'ShowAll',params:{type:'best_shops'}}" class="font-4 text-decoration-none p-3 bg-white rounded-3 position-relative">همه</router-link>
      </div>

      <div v-if="HomePage.best_shops.length > 0" class="list_category mb-5 w-100">

        <router-link v-for="(item, index) in HomePage.best_shops.slice(0, 5)" :key="index" :to="{name:'DetailsProducts',params:{pid:item.products.id}}" class="mx-1 text-decoration-none">

          <div class="div_prod rounded-3 p-2 bg-white">
            <div class="d-flex">
              <div class="img_prod rounded-3 animated-background">
                <img class="img_prod rounded-3" :src="item.products.pic" alt="">
              </div>

              <div class="d-flex flex-column mr-3 justify-content-around overflow-hidden">
                <p class="font-5 font-bold" :class="{'txtoverflow': item.products.name.length > 20}">{{ item.products.name }}</p>

                <div v-if="item.products.shops !== 0" class="">
                <p v-if="item.products.price_show !== item.products.price" class="font-5 font-color text-decoration-line-through">{{ item.products.price.toLocaleString() }} تومان</p>
                <p class="font-5 font-color">{{ item.products.price_show.toLocaleString() }} تومان</p>
                </div>

                <p v-else class="font-4 d-flex font-color-red font-bold">ناموجود</p>
              </div>
            </div>

            <div style="height: 1px" class="bg-unavailable w-100 my-2"></div>

            <div class="d-flex align-items-center justify-content-between">

              <div class="d-flex align-items-center w-70">
                <img style="width: 15px" src="../assets/img/store_light.svg" alt="">
                <div class="overflow-hidden d-flex align-items-center mx-1">
                  <p class="font-5" :class="{'txtoverflow': item.shopname.length >= 8}">{{ item.shopname }}</p>
                </div>

                <img class="icon-size-1" v-if="item.rate == 1" src="../assets/img/rate1.svg" alt="">
                <img class="icon-size-8" v-else-if="item.rate == 2" src="../assets/img/rate2.svg" alt="">
                <img class="icon-size-1" v-else-if="item.rate == 3" src="../assets/img/rate3.svg" alt="">
                <img class="icon-size-8" v-else-if="item.rate == 4" src="../assets/img/rate4.svg" alt="">
                <img class="icon-size-1" v-else-if="item.rate == 5" src="../assets/img/rate5.svg" alt="">
                <img class="icon-size-8" v-else-if="item.rate == 6" src="../assets/img/rate6.svg" alt="">
              </div>

              <div class="d-flex align-items-center">
                <img style="width: 15px" src="../assets/img/place_light_color.svg" alt="">
                <p class="font-5 mr-1">{{ item.city }}</p>
              </div>

            </div>
          </div>

        </router-link>
      </div>
        <p v-else class="font-3 font-color-red text-center w-100 mb-4">موردی یافت نشد</p>

      <div class="h-slider bg-color rounded-4 d-flex justify-content-center align-items-center mb-5">

        <carousel class="h-slider w-100" :items-to-show="1" :transition="2000" :autoplay="3000"
                  :wrapAround="true" :pauseAutoplayOnHover="true">

          <slide @click="click_option('slider' , item)" v-for="item in HomePage.slider" :key="item.id" class="h-slider">
            <img :src="item.pic" class="h-90 w-95 rounded-4" alt="">
          </slide>

        </carousel>
      </div>

      <div class="d-flex justify-content-between align-items-center position-relative mb-4">
        <div style="height: 5px" class="position-absolute bg-color-light w-100 center-y"></div>

        <img style="width: 3.7rem" class="font-4 p-3 bg-white rounded-3 position-relative" src="../assets/img/store_light.svg">
        <p class="font-4 p-3 bg-white rounded-3 w-50 text-center position-relative">پرفروش ترین محصولات</p>
        <router-link :to="{name:'ShowAll' , params:{type:'best_selling'}}" class="font-4 text-decoration-none p-3 bg-white rounded-3 position-relative">همه</router-link>
      </div>

      <div v-if="HomePage.best_selling.length > 0" class="list_category mb-5 w-100">

        <router-link class="mx-1 text-decoration-none" v-for="(item, index) in HomePage.best_selling.slice(0, 5)" :key="index" :to="{name:'DetailsProducts',params:{pid:item.id}}">

          <div class="div_prod rounded-3 p-2 bg-white">
            <div class="d-flex">
              <div class="img_prod rounded-3 animated-background">
                <img class="img_prod rounded-3" :src="item.pic" alt="">
              </div>

              <div class="d-flex flex-column mr-3 justify-content-around overflow-hidden">
                <p class="font-5 font-bold" :class="{'txtoverflow': item.name.length > 20}">{{ item.name }}</p>
                <p v-if="item.price_show !== item.price" class="font-5 font-color text-decoration-line-through">{{ item.price.toLocaleString() }} تومان</p>
                <p class="font-5 font-color">{{ item.price_show.toLocaleString() }} تومان</p>

              </div>
            </div>

            <div style="height: 1px" class="bg-unavailable w-100 my-2"></div>

            <div class="d-flex align-items-center justify-content-between">

              <div class="d-flex align-items-center w-70">
                <img style="width: 15px" src="../assets/img/store_light.svg" alt="">
                <div class="overflow-hidden d-flex align-items-center mx-1">
                <p class="font-5" :class="{'txtoverflow': item.shop.shopname.length >= 8}">{{ item.shop.shopname }}</p>
                </div>

                <img class="icon-size-1" v-if="item.shop.rate == 1" src="../assets/img/rate1.svg" alt="">
                <img class="icon-size-8" v-else-if="item.shop.rate == 2" src="../assets/img/rate2.svg" alt="">
                <img class="icon-size-1" v-else-if="item.shop.rate == 3" src="../assets/img/rate3.svg" alt="">
                <img class="icon-size-8" v-else-if="item.shop.rate == 4" src="../assets/img/rate4.svg" alt="">
                <img class="icon-size-1" v-else-if="item.shop.rate == 5" src="../assets/img/rate5.svg" alt="">
                <img class="icon-size-8" v-else-if="item.shop.rate == 6" src="../assets/img/rate6.svg" alt="">
              </div>

              <div class="d-flex align-items-center">
                <img style="width: 15px" src="../assets/img/place_light_color.svg" alt="">
                <p class="font-5 mr-1">{{ item.shop.city }}</p>
              </div>

            </div>

          </div>

        </router-link>

      </div>
      <p v-else class="font-3 font-color-red text-center w-100 mb-4">موردی یافت نشد</p>

    </div>
    <BottomNavigation></BottomNavigation>
  </div>

</template>

<style scoped>

.icon_search {
  width: 2rem;
  top: 50%;
  transform: translate(0, -50%);
}

.img_category {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.div_category {
  width: 7rem;
}

.img_prod {
  width: 6rem;
  height: 6rem;
}

.div_prod {
  width: 18rem;
}

.list_category {
  width: 100%;
  display: flex;
  overflow-x: scroll;
}
.h-slider{
  height: 18rem !important;
}

@media (min-width:1000px) {
  .h-slider{
    height: 23rem!important;
  }
}

</style>